import { render, staticRenderFns } from "./RelatedProducts.vue?vue&type=template&id=50650708&scoped=true&"
import script from "./RelatedProducts.vue?vue&type=script&lang=js&"
export * from "./RelatedProducts.vue?vue&type=script&lang=js&"
import style0 from "./RelatedProducts.vue?vue&type=style&index=0&id=50650708&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50650708",
  null
  
)

export default component.exports